import { useRouteLoaderData } from "@remix-run/react";

import { getBpComponentsUrl } from "~/utils/url";

import type { RootLoaderData } from "../../root";

export function HeadScripts() {
  const data = useRouteLoaderData<RootLoaderData>("root");

  return (
    <>
      {data?.nr && (
        <>
          <script dangerouslySetInnerHTML={{ __html: data.nr }} />
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `
                newrelic?.setErrorHandler((e) => {
                  const deny = [
                    // Third-party scripts
                    /Script error/,
                    // Usually noise from GTM scripts
                    /Minified React error #(423|418)/,
                  ];
                  return deny.some((d) => d.test(e?.message ?? ""));
                });

                if (window.BibleProjectApp) {
                  newrelic?.setCustomAttribute("bp.platform", window.BibleProjectApp.platform);
                  newrelic?.setCustomAttribute("bp.appVersion", window.BibleProjectApp.appVersion);
                  newrelic?.setCustomAttribute("bp.webViewVersion", window.BibleProjectApp.webViewVersion);
                }
              `,
            }}
          />
        </>
      )}

      {data?.env && (
        <>
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `window.__env__ = ${JSON.stringify(data.env)}`,
            }}
          />
          <script
            type="module"
            dangerouslySetInnerHTML={{
              __html: `
              import { set } from "${getBpComponentsUrl("env.js")}";
              set("API_URL", "${data.env.BP_COMPONENTS_API_URL}");
              set("USER_API_URL", "${data.env.BP_COMPONENTS_USER_API_URL}");
              set("SEARCH_API_URL", "${data.env.SEARCH_API_URL}");
              set("SEARCH_API_TOKEN", "${data.env.SEARCH_API_TOKEN}");
            `,
            }}
          />
          <script
            type="module"
            crossOrigin="anonymous"
            src={`${getBpComponentsUrl("bp.js")}`}
          />
        </>
      )}
    </>
  );
}
